import React from 'react';
import { useAppSelector } from '../../../careand-redux/store';
import DefaultConfirmationModal, {
  DefaultConfirmationModalProps,
} from '../DefaultConfirmationScreen';
import ConfirmationDialog, { ConfirmationDialogProps, ConfirmationFormItem } from './index';

function ConfirmationDialogWrapper<T extends readonly ConfirmationFormItem<string>[]>(
  props: Omit<DefaultConfirmationModalProps, 'onConfirm'> | ConfirmationDialogProps<T>,
) {
  const ownRole = useAppSelector((state) => state.authentication.role);

  return ownRole === 'patient' ? (
    <DefaultConfirmationModal
      {...(props as DefaultConfirmationModalProps)}
      textElement={(props as any).message}
    />
  ) : (
    <ConfirmationDialog {...(props as ConfirmationDialogProps<T>)} />
  );
}

export default ConfirmationDialogWrapper;
